<p-dialog header="{{ !researchInfrastructureUsage.researchInfrastructureUsageType ? ('fs.res.researchInfrastructure.ResearchInfrastructure.add'+i18nKey|hisUi:(hisDdKey|hisUi)) : ('fs.res.researchInfrastructure.ResearchInfrastructure.edit'+i18nKey|hisUi)}}" 
    [(visible)]="visibility" [modal]="true" height="auto" (onHide)="closeDialog()" [draggable]="false" [blockScroll]="true">

    <div class="layoutBlock">
        <div class="columnFullWidth">
            <his-plam>
                <p-inputNumber #content hisDdKey="fs.res.researchInfrastructure.ResearchInfrastructureUsage.usageYear" 
                    [(ngModel)]="researchInfrastructureUsage.usageYear"
                    [maxlength]="4" [useGrouping]="false">
                </p-inputNumber>
            </his-plam>
            <his-plam>
                <p-inputNumber #content [maxlength]="9" [useGrouping]="false"
                    [hisDdKey]="hisDdKey + 'Amount'"
                    [(ngModel)]="researchInfrastructureUsage.usageAmount">
                </p-inputNumber>
            </his-plam>
        </div>
    </div>

    <p-footer>
        <button (click)="applyChanges()" (keydown.tab)="$event.preventDefault(); $event.stopPropagation(); cancelBtn.focus();">
            <span>{{ 'common.apply' | hisUi }}</span>
        </button>
        <button #cancelBtn (click)="closeDialog()">
            <span>{{ 'common.cancel' | hisUi }}</span>
        </button>
     </p-footer>
</p-dialog>
